import { StringCafsValue } from "../../../../../../api/types/cafs";
import { InputDefinition } from "../../../../../../api/types/inputs";

const pickNumber = (cv: StringCafsValue | undefined): number =>
  ((cv?.Base !== "" ? Number(cv?.Base) : undefined) ??
    Number(cv?.Current) ??
    0) as number;

export const npkRatioFn = (
  values: Record<keyof InputDefinition, StringCafsValue>,
): string => {
  const biomDMN = pickNumber(values.BiomDMN);
  const biomDMP = pickNumber(values.BiomDMP);
  const biomDMK = pickNumber(values.BiomDMK);
  const seasonalDM = pickNumber(values.SeasonalInputDMContent);

  const int1 = Math.round((biomDMN / 10) * seasonalDM);
  const int2 = Math.round(((biomDMP * 2.29) / 10) * seasonalDM);
  const int3 = Math.round(((biomDMK * 1.205) / 10) * seasonalDM);

  return `${int1}-${int2}-${int3}`;
};
